import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button";
import useInView from "../../hooks/useInView";

export default function WorkSection() {
  const [isMobile, setIsMobile] = useState(false);
  const [ref, isInView] = useInView();
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const works = [
    {
      id: "work-project-1",
      slug: "the-artist-and-the-pervert",
      title: "The Artist & The Pervert",
      desc: "A documentary about intimacy, power, and consent. Two people let us into their lives. No script. No shortcuts.",
      imageWebp: "/images/work/artist-pervert.webp",
      imageJpg: "/images/work/artist-pervert.jpg",
      alt: "The Artist and the Pervert documentary by Renée Gebhardt and Beatrice Behn: Georg Friedrich Haas and Mollena Williams-Haas",
    },
    {
      id: "work-project-2",
      slug: "ikea-cinema-catalogue",
      title: "IKEA Cinema Catalogue",
      desc: "Turning a catalogue into a movie. Literally. Usually, catalogue advertising is ignored. This one made people watch.",
      imageWebp: "/images/work/ikea-cinema.webp",
      imageJpg: "/images/work/ikea-cinema.jpg",
      alt: "IKEA Cinema Catalogue campaign by Renée Gebhardt: Cannes Lions-winning guerilla stunt turning the IKEA catalogue into a film",
    },
    {
      id: "work-project-3",
      slug: "karada-house",
      title: "Karada House",
      desc: "Started in a horse stable. Moved into a church. Six years of art, workshops, and conferences for people who need space.",
      imageWebp: "/images/work/karada-house.webp",
      imageJpg: "/images/work/karada-house.jpg",
      alt: "queer kink and art space in a former church, co-founded by Renée Gebhardt in 2019",
    },
  ];

  return (
    <>
      <style>{`
        .home-work-image-wrap {
          position: relative;
          overflow: hidden;
          border-radius: 2px;
          background-color: #27272a;
          cursor: pointer;
        }
        .home-work-image {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          filter: brightness(1.0);
          transition: filter 0.3s ease-out;
          will-change: filter;
          transform: translateZ(0);
        }
        .home-work-image-wrap:hover .home-work-image {
          filter: brightness(1.15);
        }
        .home-work-title {
          color: #fff;
          transition: color 0.2s ease;
          cursor: pointer;
          display: inline;
        }
        .home-work-title:hover {
          color: #71717a;
        }
      `}</style>

      <section
        ref={ref}
        className="section-padding"
        style={{ backgroundColor: "#000" }}
        id="work"
      >
        <div
          style={{
            maxWidth: "1600px",
            margin: "0 auto",
            padding: isMobile ? "0 0px" : "0 25px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "100px" }}>
            <h2
              id="work-section-header"
              className="heading-section"
              style={{ marginBottom: "24px" }}
            >
              <span className="fade-in-delay-1">SELECTED</span>
              <br />
              <span className="fade-in-delay-2">WORK</span>
            </h2>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "100px",
              marginBottom: "120px",
            }}
          >
            {works.map((work, idx) => {
              const isEven = idx % 2 === 0;
              const url = `/work/${work.slug}`;

              return (
                <div
                  key={work.id}
                  id={work.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: isMobile
                      ? "1fr"
                      : isEven
                      ? "2fr 1fr"
                      : "1fr 2fr",
                    gap: isMobile ? "15px" : "20px",
                    alignItems: "center",
                  }}
                >
                  {/* Image */}
                  <div
                    className="home-work-image-wrap"
                    style={{ order: isMobile ? 1 : isEven ? 1 : 2 }}
                    onClick={() => navigate(url)}
                  >
                    <div style={{ paddingBottom: "56.25%", position: "relative" }}>
                      <picture>
                        <source srcSet={work.imageWebp} type="image/webp" />
                        <img
                          src={work.imageJpg}
                          alt={work.alt}
                          loading="lazy"
                          className="home-work-image"
                        />
                      </picture>
                    </div>
                  </div>

                  {/* Text */}
                  <div
                    style={{
                      order: isMobile ? 2 : isEven ? 2 : 1,
                      padding: isMobile
                        ? "0"
                        : isEven
                        ? "0 0 0 20px"
                        : "0 20px 0 0",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px" }}>
                      <a
                        href={url}
                        className="home-work-title"
                        style={{
                          fontFamily: "Archivo, sans-serif",
                          fontWeight: "700",
                          fontSize: "24px",
                          textDecoration: "none",
                        }}
                      >
                        {work.title}
                      </a>
                    </h3>

                    <p className="body-medium" style={{ marginBottom: "12px" }}>
                      {work.desc}
                    </p>

                    {work.awards && (
                      <p className="body-small" style={{ fontStyle: "italic" }}>
                        {work.awards}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ textAlign: "center", marginTop: "100px" }}>
            <Button href="/work">SEE ALL WORK</Button>
          </div>
        </div>
      </section>
    </>
  );
}